import $ from 'jquery';
import noop from 'cmnjs/function/noop';
import config from './config';
import overlay from './overlay';

let $opacityLayer;
let $footer;

let checkOpacityLayer = function () {
  return $footer.offset().top > config.$el.window.scrollTop() + config.$el.window.height();
};

function showHideLayer(show) {
  overlay[`${show ? 'show' : 'hide'}Overlay`]($opacityLayer, 1);
}

export default {

  init() {
    $opacityLayer = $('.page-opacity-layer');
    $footer = $('footer');

    if (!$opacityLayer.length) {
      checkOpacityLayer = noop;
    }
  },

  resize() {
    // coś będzie na resize?
  },

  scroll() {
    showHideLayer(checkOpacityLayer());
  },

};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/opacityLayer.js